import * as React from 'react'

import { CredentialsFields } from 'main/gql/credentials'
import { UnreachableCaseError } from 'main/util/ts'
import Confirmation from './steps/Confirmation'
import Contact from './steps/Contact'
import Login from './steps/Login'
import SignUp from './steps/SignUp'
import { track, TrackData } from './track'
import { Step, StepName } from './types'

interface IProps {
  trackData: TrackData
  step: Step
  onChangeStep: (step: Step) => void
  onAuth: (credentials: CredentialsFields) => void
  onComplete?: (callbackData?: {}) => void
  onDone: () => void
}

export default function StepContent(props: IProps) {
  const { trackData, step, onChangeStep, onComplete, onAuth, onDone } = props
  const { schoolContainer } = step

  switch (step.__stepname) {
    case StepName.SignUp:
      return (
        <SignUp
          schoolContainer={schoolContainer}
          onRequestLogin={() => onChangeStep({ __stepname: StepName.Login, schoolContainer })}
          onComplete={credentials => {
            track('completed_sign_up', schoolContainer.__type, trackData)
            handleAuth(credentials)
          }}
        />
      )

    case StepName.Login:
      return (
        <Login
          schoolContainer={schoolContainer}
          onRequestSignUp={() => onChangeStep({ __stepname: StepName.SignUp, schoolContainer })}
          onComplete={credentials => {
            track('completed_login', schoolContainer.__type, trackData)
            handleAuth(credentials)
          }}
        />
      )

    case StepName.Contact:
      return (
        <Contact
          user={step.user}
          schoolContainer={schoolContainer}
          onComplete={(callbackData?: {}) => {
            track('completed_contact', schoolContainer.__type, trackData)
            if (onComplete) {
              onComplete(callbackData)
            }

            onChangeStep({
              __stepname: StepName.Confirmation,
              schoolContainer,
              user: step.user,
            })
          }}
        />
      )

    case StepName.Confirmation:
      return (
        <Confirmation
          onComplete={() => {
            track('completed_confirmation', schoolContainer.__type, trackData)
            onDone()
          }}
          user={step.user}
        />
      )

    default:
      throw new UnreachableCaseError(step)
  }

  function handleAuth(credentials: CredentialsFields) {
    onAuth(credentials)
    onChangeStep({
      __stepname: StepName.Contact,
      schoolContainer,
      user: credentials.user,
    })
  }
}
